import React, { useState, useEffect } from 'react';
import { Button, Backdrop, CircularProgress } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useSnackbar } from 'notistack';

import Api from '../../../Api';
import Modal from '../../../components/Modal/Modal';
import FolderTreeSelect from './FolderTreeSelect';

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 200px) !important'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    color: '#fff'
  }
}));

// allFolders: flat list of all folders (managers). file: the file being moved.
// A file must always live inside a folder (folder_id NOT NULL), so there is no "root" option.
const MoveFileModal = ({ handleClose, visibility, file, allFolders }) => {
  const { enqueueSnackbar } = useSnackbar();
  const styles = useStyles();

  const [destination, setDestination] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDestination(null);
  }, [visibility, file]);

  // Disable (but still show) the folder the file already lives in, so its
  // subfolders remain visible and selectable as destinations.
  const currentFolderId = file && file.folder_id != null ? Number(file.folder_id) : null;
  const disabledIds = new Set();
  if (currentFolderId != null) {
    disabledIds.add(currentFolderId);
  }

  const handleCloseDismiss = () => {
    handleClose();
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (!destination || destination.id == null) return;
    setLoading(true);

    Api.put('/drive_files/' + file.id, { folder_id: destination.id })
      .then(function() {
        setLoading(false);
        enqueueSnackbar('Archivo movido exitosamente!', {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'success'
        });
        handleClose(true);
      })
      .catch(function(error) {
        setLoading(false);
        var message = 'Error de conexion, contacta a soporte';
        if (error.response) {
          message = 'Ocurrio un error, intenta nuevamente.';
        }
        enqueueSnackbar(message, {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'error'
        });
      });
  };

  return (
    <div>
      <Modal handleClose={handleCloseDismiss} visibility={visibility} title={'Mover ' + (file ? file.name : '')} maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            <FolderTreeSelect
              folders={allFolders}
              selectedId={destination ? destination.id : undefined}
              onSelect={setDestination}
              disabledIds={disabledIds}
            />
          </DialogContent>
          <DialogActions>
            <Button disabled={!destination} type="submit" color="primary">
              {destination ? 'Mover a "' + destination.name + '"' : 'Mover'}
            </Button>
          </DialogActions>
        </form>
      </Modal>
      <Backdrop className={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default MoveFileModal;
